import React, { useState } from "react";
import SvgIcon from "../../../Components/Common/Component/SvgIcon";
import {
  CHECKALL,
  DeliveryComplete,
  DeliveryProcessing,
  Notification,
  OrderComplete,
  TicketsGenerated,
} from "../../../Constant";

const Notificationbar = () => {
  const [notificationDropDown, setNotificationDropDown] = useState(false);

  return (
    <li className="onhover-dropdown">
      <div
        className="notification-box"
        onClick={() => setNotificationDropDown(!notificationDropDown)}
      >
        <SvgIcon iconId="notification" />
        <span className="badge rounded-pill badge-secondary">0</span>
      </div>
      <div
        className={`notification-dropdown onhover-show-div ${notificationDropDown ? "active" : ""}`}
      >
        <h6 className="f-18 mb-0 dropdown-title">{Notification}</h6>
      </div>
    </li>
  );
};

export default Notificationbar;
